import React from "react"
import PropTypes from "prop-types"

function MainWrapper({ children }) {
  return <div id="main-wrapper">{children}</div>
}

MainWrapper.propTypes = {
  children: PropTypes.node,
}

MainWrapper.defaultProps = {
  children: null,
}

export default MainWrapper



// WEBPACK FOOTER //
// ./src/components/layout/MainWrapper.jsx